import Logger from '@KrashidBuilt/common/utils/logger';
import _ from 'lodash';

const logger = new Logger('utils/jobs');

const getFieldsFromTemplate = ($, template, filters) => {
    if (!$ || !template) {
        return [];
    }

    logger.extra({ $, template, filters });

    const fields = [];

    template.json_data.fields.map(({ type, label, path }) => {
        let value = '';
        try {
            if (path.func) {
                // we create a function on the backend that can be invoked to return the data in the correct format (aggregating keys etc)
                const fn = new Function(`return ${path.func}`)();
                value = fn($, filters);
            } else if (path.filter && path.filter?.length >= 1) {
                // turn a path like this "job.JobPhases[?].JobPhaseName"
                // into a resolving path like this "job.JobPhases[0].JobPhaseName"

                let constructed = JSON.parse(JSON.stringify(path._));

                for (let i = 0; i < path.filter?.length; i++) {
                    const p = constructed.split('[?]')[0];
                    const f = path.filter[i];
                    const array = _.get($, p, []);
                    const idx = array.findIndex((v) => filters[f.key] && filters[f.key].value === v[f.key] || v[f.key] === f.default);
                    constructed = constructed.replace('[?]', `[${idx}]`);
                }

                value = _.get($, constructed, '');
            } else {
                // grab this value from the path using lodash
                value = _.get($, path._, '');
            }

        } catch (error) {
            logger.error('Unable to get from ', { type, label, path }, error);
        }
        fields.push({ type, label, value });
    });

    return fields;
};

export default {
    getFieldsFromTemplate
};
